if ($('.portfolio-nav').length > 0) {
	const portfolioNav = $('.js-portfolioNav').html();

	$('header').append(portfolioNav);
	$('.js-portfolioNav').remove();
}